import { Absent_getInstance17o8jlyfouexf as Absent_getInstance } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SavePairAssignmentsInputClass;
function SavePairAssignmentsInput() {
  if (SavePairAssignmentsInputClass === VOID) {
    class $ {
      constructor(partyId, pairingSetId, date, pairs, discordMessageId, slackMessageId) {
        discordMessageId = discordMessageId === VOID ? Absent_getInstance() : discordMessageId;
        slackMessageId = slackMessageId === VOID ? Absent_getInstance() : slackMessageId;
        this.b6r_1 = partyId;
        this.c6r_1 = pairingSetId;
        this.d6r_1 = date;
        this.e6r_1 = pairs;
        this.f6r_1 = discordMessageId;
        this.g6r_1 = slackMessageId;
      }
      toString() {
        return 'SavePairAssignmentsInput(partyId=' + this.b6r_1.toString() + ', pairingSetId=' + this.c6r_1.toString() + ', date=' + this.d6r_1.toString() + ', pairs=' + toString(this.e6r_1) + ', discordMessageId=' + toString(this.f6r_1) + ', slackMessageId=' + toString(this.g6r_1) + ')';
      }
      hashCode() {
        var result = this.b6r_1.hashCode();
        result = imul(result, 31) + this.c6r_1.hashCode() | 0;
        result = imul(result, 31) + this.d6r_1.hashCode() | 0;
        result = imul(result, 31) + hashCode(this.e6r_1) | 0;
        result = imul(result, 31) + hashCode(this.f6r_1) | 0;
        result = imul(result, 31) + hashCode(this.g6r_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePairAssignmentsInput()))
          return false;
        if (!this.b6r_1.equals(other.b6r_1))
          return false;
        if (!this.c6r_1.equals(other.c6r_1))
          return false;
        if (!this.d6r_1.equals(other.d6r_1))
          return false;
        if (!equals(this.e6r_1, other.e6r_1))
          return false;
        if (!equals(this.f6r_1, other.f6r_1))
          return false;
        if (!equals(this.g6r_1, other.g6r_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePairAssignmentsInput');
    SavePairAssignmentsInputClass = $;
  }
  return SavePairAssignmentsInputClass;
}
//region block: exports
export {
  SavePairAssignmentsInput as SavePairAssignmentsInput3tgrc8c2zd524,
};
//endregion

//# sourceMappingURL=SavePairAssignmentsInput.mjs.map
